(function () {
  'use strict';

  function loadScript(src) {
    if (!src) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        resolve();
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject(new Error('Failed to load ' + src));
      };
      document.head.appendChild(script);
    });
  }

  function loadWhenIdle(callback, timeout) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout: timeout || 2500 });
      return;
    }

    window.setTimeout(callback, timeout || 1500);
  }

  function isHydeCroPerf() {
    return document.documentElement.getAttribute('data-hyde-cro-perf') === '1';
  }

  function initConditionalScripts() {
    var root = document.currentScript;
    if (!root) return;

    var hydeCroPerf = isHydeCroPerf();

    if (document.querySelector('[data-rabitat-marquee]')) {
      loadScript(root.getAttribute('data-marquee-src'));
    }

    var dragScrollSelectors = [
      '[data-spares-viewport]',
      '[data-career-reviews-viewport]',
      '[data-career-team-viewport]',
      '[data-birthday-reviews-viewport]',
      '[data-birthday-bulk-viewport]',
      '.rabitat-celebrities__viewport',
      '.rabitat-press__viewport',
      '.rabitat-product-page__thumbs',
      '.rabitat-purecore__tabs',
      '.rabitat-category-nav__viewport',
      '[data-rabitat-drag-scroll]',
      '[data-collection-viewport]',
    ].join(',');

    var needsSliderTouch =
      document.querySelector(dragScrollSelectors) ||
      document.querySelector('[data-hero-slider], [data-launches-slider]');

    if (needsSliderTouch) {
      loadScript(root.getAttribute('data-slider-src'));
    }

    var needsProductCard = document.querySelector(
      '[data-collection-carousel], [data-product-card], .rabitat-product-card, .rabitat-product-card-cro, .rabitat-supplement-card'
    );

    if (needsProductCard) {
      loadScript(root.getAttribute('data-responsive-image-src')).then(function () {
        return loadScript(root.getAttribute('data-product-card-src'));
      });
    }

    if (!hydeCroPerf && document.querySelector('a[href^="#"]')) {
      loadWhenIdle(function () {
        loadScript(root.getAttribute('data-smooth-scroll-src'));
      }, 2000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConditionalScripts);
  } else {
    initConditionalScripts();
  }
})();
